module.exports = __webpack_public_path__ + "img/Silvestre_Vivo.8f2554b0.jpg";